import React, { useEffect, useState } from 'react';
import propTypes from 'prop-types';
import { connect } from 'react-redux';

import FontAwesome from 'react-fontawesome';

import { deleteCalendarAccount } from '~/Redux/Modules/CalendarAccounts';
import { useConfirmDisconnect } from '~/Components/ConfirmDisconnectAccount';
import { useMountEffect } from '~/util';
import mParticle, { CalendarAccountExpandedEvent } from '~/Providers/mParticle';
import { APPLE } from '~/Config/Drivers';

const AddAccountForm = props => {
  const [expanded, setExpanded] = useState(null);
  const [prevAccount, setPrevAccount] = useState(null);
  const [prevFetching, setPrevFetching] = useState(null);
  const confirmDisconnect = useConfirmDisconnect();
  const { account, fetching } = props;

  const handleCheckClick = e => {
    const { account, deleteCalendarAccount } = props;
    if (account && deleteCalendarAccount) {
      e.preventDefault();
      e.stopPropagation();
      confirmDisconnect({ accountType: account.driver }).then(() => deleteCalendarAccount(account));
    }
  };

  const handleExpanded = e => {
    const { account } = props;
    setExpanded(!expanded);
    if (expanded && !account) {
      mParticle.logEvent(new CalendarAccountExpandedEvent(APPLE));
    }
  };

  useEffect(() => {
    if (expanded != null) return;
    const { account, fetching } = props;
    if ((!prevAccount && account) || (!prevFetching && fetching)) {
      setExpanded(true);
    }

    setPrevAccount(!!account);
    setPrevFetching(fetching);
  }, [account, fetching]);

  const { logo, children, imgStyle, imgText } = props;
  return (
    <>
      <p key="a" onClick={handleExpanded} style={{ cursor: 'pointer' }}>
        <FontAwesome
          name={expanded ? 'caret-down' : 'caret-right'}
          size="2x"
          style={{ fontSize: '1.5rem', marginRight: '0.5rem' }}
        />
        Connect with{' '}
        <img style={imgStyle || { width: '9.0rem', paddingLeft: '1.0rem' }} src={logo} alt="" />{' '}
        {imgText}
        <FontAwesome
          className="account-check"
          name={`check-circle ${account && 'complete'}`}
          size="2x"
          onClick={handleCheckClick}
        />
      </p>
      <hr key="ab" /> {expanded && children}
    </>
  );
};

AddAccountForm.propTypes = {
  logo: propTypes.string,
  children: propTypes.node,
  complete: propTypes.object,
  deleteCalendarAccount: propTypes.func,
  account: propTypes.object,
  fetching: propTypes.bool,
  imgStyle: propTypes.object,
  imgText: propTypes.string,
};

const mapStateToProps = () => ({});

const mapDispatchToProps = dispatch => {
  return {
    deleteCalendarAccount: account => dispatch(deleteCalendarAccount(account)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(AddAccountForm);
